import { render, staticRenderFns } from "./units-modal-basic-form.vue?vue&type=template&id=163ca13c&"
import script from "./units-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./units-modal-basic-form.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports